/* Widerruf-Formular (AUFTRAG-98). Sendet an den Portal-Endpunkt aus der Theme-Einstellung.
   Ohne Endpunkt läuft eine Attrappe (Testshop) mit derselben Antwortform: { ok, eingangZeit (ISO, Europe/Berlin), referenz }.
   Prüffehler des Portals (HTTP 400/422 oder ok:false mit { fehler: [{ feld, text }] }) erscheinen am jeweiligen Feld;
   der Fehlerfall mit E-Mail-Ausweichweg gilt nur für Netzwerkfehler, Zeitüberschreitung, 5xx und Antworten ohne verwertbare Feldmeldung.
   Kein localStorage, keine Cookies, keine Fremdbibliothek. */
(function () {
  'use strict';
  var root = document.querySelector('[data-wf]');
  if (!root) return;
  var cfgEl = root.parentNode.querySelector('[data-wf-config]') || document.querySelector('[data-wf-config]');
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var T = cfg.texts;
  var form = root.querySelector('[data-wf-form]');
  var summary = root.querySelector('[data-wf-summary]');
  var summaryText = summary.textContent;
  var SERVER_FIELDS = ['name', 'bestellnummer', 'email'];
  var btn = root.querySelector('[data-wf-submit]');
  var done = root.querySelector('[data-wf-done]');
  var fail = root.querySelector('[data-wf-fail]');
  var fields = {};
  form.querySelectorAll('[data-wf-field]').forEach(function (el) { fields[el.getAttribute('data-wf-field')] = el; });
  var errs = {};
  form.querySelectorAll('[data-wf-err]').forEach(function (el) { errs[el.getAttribute('data-wf-err')] = el; });
  var lang = (document.documentElement.lang || cfg.locale || 'en');
  var busy = false;

  /* Bestellnummer aus Kundenkonto-Link vorbelegen: ?bestellung=#1001 */
  try {
    var pre = new URLSearchParams(window.location.search).get('bestellung');
    if (pre && /^[#A-Za-z0-9._\-]{1,30}$/.test(pre)) fields.bestellnummer.value = pre;
  } catch (e) { /* ohne Vorbelegung weiter */ }

  function setErr(name, msg) {
    var f = fields[name], e = errs[name];
    if (!f || !e) return;
    if (msg) { e.textContent = msg; e.hidden = false; f.setAttribute('aria-invalid', 'true'); }
    else { e.textContent = ''; e.hidden = true; f.removeAttribute('aria-invalid'); }
  }

  function validate() {
    var bad = [];
    var name = fields.name.value.trim();
    var order = fields.bestellnummer.value.trim();
    var mail = fields.email.value.trim();
    setErr('name', name ? '' : T.required); if (!name) bad.push('name');
    if (!order) { setErr('bestellnummer', T.order); bad.push('bestellnummer'); }
    else if (!/^[#A-Za-z0-9._\-]{1,30}$/.test(order) || !/[0-9]/.test(order)) { setErr('bestellnummer', T.order); bad.push('bestellnummer'); }
    else setErr('bestellnummer', '');
    if (!mail) { setErr('email', T.emailRequired); bad.push('email'); }
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail)) { setErr('email', T.email); bad.push('email'); }
    else setErr('email', '');
    if (bad.length) {
      summary.textContent = summaryText;
      summary.hidden = false;
      fields[bad[0]].focus();
    } else summary.hidden = true;
    return bad.length === 0;
  }

  function maskEmail(m) {
    var at = m.lastIndexOf('@');
    if (at < 1) return m;
    return m.charAt(0) + '***' + m.slice(at);
  }

  function fmt(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return null;
    var loc = /^en/i.test(lang) ? 'en-GB' : lang;
    var date, time;
    try {
      date = new Intl.DateTimeFormat(loc, { timeZone: 'Europe/Berlin', day: '2-digit', month: '2-digit', year: 'numeric' }).format(d);
      time = new Intl.DateTimeFormat(loc, { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit', hour12: false }).format(d);
    } catch (e) {
      date = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', day: '2-digit', month: '2-digit', year: 'numeric' }).format(d);
      time = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit', hour12: false }).format(d);
    }
    return { date: date, time: time };
  }

  /* Attrappe: gleiche Antwortform wie der Portal-Endpunkt. Nur wenn keine Endpunkt-Adresse eingetragen ist. */
  function mock(payload) {
    return new Promise(function (resolve, reject) {
      window.setTimeout(function () {
        var q = '';
        try { q = new URLSearchParams(window.location.search).get('wf_test') || ''; } catch (e) { q = ''; }
        if (q === 'fehler') { reject(new Error('mock-unreachable')); return; }
        var now = new Date();
        var p = {};
        new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false, timeZoneName: 'longOffset' })
          .formatToParts(now).forEach(function (x) { p[x.type] = x.value; });
        var off = (p.timeZoneName || 'GMT+00:00').replace('GMT', '') || '+00:00';
        if (off.length === 3) off += ':00';
        var hh = p.hour === '24' ? '00' : p.hour;
        resolve({ ok: true, eingangZeit: p.year + '-' + p.month + '-' + p.day + 'T' + hh + ':' + p.minute + ':' + p.second + off, referenz: 'WDR-TEST-' + String(now.getTime()).slice(-6) });
      }, 700);
    });
  }

  function send(payload) {
    /* Ohne Endpunkt-Adresse nur im Testshop eine Attrappe; sonst gilt der Fehlerfall mit E-Mail-Ausweichweg (nie eine vorgetäuschte Bestätigung im Live-Shop). */
    if (!cfg.endpoint) {
      if (window.location.hostname === 'cryonos-test.myshopify.com') return mock(payload);
      return Promise.reject(new Error('no-endpoint'));
    }
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? window.setTimeout(function () { ctrl.abort(); }, 15000) : null;
    return fetch(cfg.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      if (timer) window.clearTimeout(timer);
      if (!r.ok) {
        var he = new Error('http-' + r.status);
        he.status = r.status;
        /* 4xx: Antworttext lesen, damit Feldmeldungen des Portals angezeigt werden können. */
        if (r.status >= 400 && r.status < 500) return r.json().then(function (b) { he.body = b; throw he; }, function () { throw he; });
        throw he;
      }
      return r.json();
    }, function (e) { if (timer) window.clearTimeout(timer); throw e; });
  }

  function showDone(res, payload) {
    var f = fmt(res.eingangZeit);
    if (!f) { showFail(payload); return; }
    var txt = T.done.replace('[date]', f.date).replace('[time]', f.time).replace('[email]', maskEmail(payload.email));
    root.querySelector('[data-wf-donetext]').textContent = txt;
    var ref = root.querySelector('[data-wf-ref]');
    if (res.referenz) { ref.textContent = T.ref.replace('[ref]', String(res.referenz)); ref.hidden = false; } else ref.hidden = true;
    if (!cfg.endpoint) { var tn = root.querySelector('[data-wf-donetext]'); tn.textContent = '[TEST-ATTRAPPE: nothing was sent / es wurde nichts gesendet] ' + tn.textContent; }
    form.hidden = true; fail.hidden = true; done.hidden = false;
    done.focus();
  }

  /* Feldmeldungen des Portals: { ok:false, fehler:[{ feld:'bestellnummer', text:'…' }] }. Gibt false zurück, wenn nichts Verwertbares darin steht. */
  function serverErrors(body) {
    if (!body || !Array.isArray(body.fehler)) return false;
    var per = {}, rest = [], first = null;
    body.fehler.forEach(function (x) {
      if (!x || typeof x.text !== 'string' || !x.text.trim()) return;
      var t = x.text.trim();
      if (SERVER_FIELDS.indexOf(x.feld) > -1) { per[x.feld] = per[x.feld] ? per[x.feld] + ' ' + t : t; if (!first) first = x.feld; }
      else rest.push(t);
    });
    if (!first && !rest.length) return false;
    SERVER_FIELDS.forEach(function (k) { setErr(k, per[k] || ''); });
    if (rest.length) { summary.textContent = rest.join(' '); summary.hidden = false; } else summary.hidden = true;
    form.hidden = false; done.hidden = true; fail.hidden = true;
    if (first) fields[first].focus(); else summary.focus();
    return true;
  }

  function showFail(payload) {
    var mailto = 'mailto:' + cfg.mail + '?subject=' + encodeURIComponent(T.mailSubject + payload.bestellnummer.replace(/^#/, '')) +
      '&body=' + encodeURIComponent(payload.name + '\n' + payload.bestellnummer + '\n' + payload.email);
    root.querySelector('[data-wf-failtext]').textContent = T.error.replace('[mail]', cfg.mail);
    root.querySelector('[data-wf-mail]').setAttribute('href', mailto);
    form.hidden = true; done.hidden = true; fail.hidden = false;
    fail.focus();
  }

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    if (busy) return;
    if (!validate()) return;
    var payload = {
      name: fields.name.value.trim(),
      bestellnummer: fields.bestellnummer.value.trim(),
      email: fields.email.value.trim(),
      shop: window.location.hostname,
      sprache: lang.slice(0, 2),
      website: fields.website ? fields.website.value : ''
    };
    busy = true;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = T.sending;
    send(payload).then(function (res) {
      if (res && res.ok === true && res.eingangZeit) showDone(res, payload);
      else if (!serverErrors(res)) showFail(payload);
    }).catch(function (err) {
      /* Nur 4xx mit Feldmeldungen bleiben im Formular; Netzwerkfehler, Zeitüberschreitung und 5xx führen zum E-Mail-Ausweichweg. */
      if (!(err && err.status >= 400 && err.status < 500 && serverErrors(err.body))) showFail(payload);
    }).then(function () {
      busy = false; btn.disabled = false; btn.removeAttribute('aria-busy');
      btn.innerHTML = '';
      btn.appendChild(document.createTextNode(T.submit + ' '));
      var ar = document.createElement('span'); ar.setAttribute('aria-hidden', 'true'); ar.textContent = '→'; btn.appendChild(ar);
    });
  });

  root.querySelector('[data-wf-retry]').addEventListener('click', function () {
    fail.hidden = true; form.hidden = false; fields.name.focus();
  });
  Object.keys(fields).forEach(function (k) {
    fields[k].addEventListener('input', function () { if (fields[k].getAttribute('aria-invalid')) setErr(k, ''); });
  });
})();
